module.exports = __webpack_public_path__ + "static/img/setingu6.0a7d207a.png";